import { useState, useEffect } from "react";
import { getAuthToken } from "../../authToken";

const useVerifInternet = () => {
    const user_id = localStorage.getItem('user_id');
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    // Fonction pour vérifier la connexion à un serveur (ex: Google)
    const checkConnection = async () => {
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            if (response.ok) {
                setIsOnline(true);  // Connexion validée
            } else {
                setIsOnline(false); // Problème de connexion
            }
        } catch (error) {
            setIsOnline(false); // Erreur, hors ligne
        }
    };

    useEffect(() => {

        const handleOnline = () => {
            setIsOnline(true);
        };

        const handleOffline = () => {
            setIsOnline(false);
        };

        // Écouteurs d'événements pour les changements en ligne/hors ligne
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        // Vérification périodique de la connexion à un serveur
        const interval = setInterval(checkConnection, 1000); // Vérifie toutes les 2 secondes

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
            clearInterval(interval);  // Arrêt de la vérification périodique
        };
    }, []);


    return isOnline;
};

export default useVerifInternet;
